// extracted by mini-css-extract-plugin
export default {"parent":"formInput_parent__KvXje","parentErrorInform":"formInput_parentErrorInform__BM+RZ"};